import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { mapGetters } from 'vuex'
import router from '../../router/index'
import TransactionsDetailedHeader from '../TransactionsDetailedHeader/index'
import Toast from '../Toast/component'
export default {
  name: 'DMIStep1',
  components: { TransactionsDetailedHeader, VueSlider, Toast },
  props: [],
  data () {
    return {
      incorrectDateFormat: false, incorrectPAN: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'userDetails',
      appliedToDmi: 'appliedToDmi',
      invalidPinCode: 'invalidEmploymentPinCode',
      disablePanField: 'disablePanField'
    })
  },
  mounted () {
    this.getUserDetails()
  },
  methods: {
    getUserDetails () {
      this.$store.dispatch('userDetails')
    },
    getPinCodeDetails (personal, pincode = '') {
      if (pincode.length === 6) {
        this.$store.dispatch('pinCode', { pincode, personal })
      }
    },
    startDMI () {
      !this.incorrectDateFormat && !this.invalidPinCode && router.push({ path: 'step-2' })
    },
    validateDate (event) {
      const allowedChars = '0123456789'
      function contains (stringValue, charValue) {
        return stringValue.indexOf(charValue) > -1
      }
      const invalidKey = event.key.length === 1 && !contains(allowedChars, event.key)
      if (!invalidKey && event.key !== 'Backspace' && event.key !== 'Delete') {
        this.incorrectDateFormat = false
        const regex = new RegExp('^([0-9]{2}/[0-9]{4})$')
        if (this.user.employmentDetail.workingSince.length === 2) {
          this.user.employmentDetail.workingSince += '/'
        }
        if (this.user.employmentDetail.workingSince.length === 7) {
          if (
            !(
              parseInt(this.user.employmentDetail.workingSince.slice(0, 2)) <=
              12 &&
              this.user.employmentDetail.workingSince.slice(3, 7) <=
              new Date().getFullYear() &&
              regex.test(this.user.employmentDetail.workingSince)
            )
          ) {
            this.incorrectDateFormat = true
          }
          // console.log(this.user.employmentDetail.workingSince.slice(3, 7))
        }
      } else {
        this.user.employmentDetail.workingSince = this.user.employmentDetail.workingSince.replace(/[a-zA-Z]/g, '')
      }
    },
    validatePAN () {
      this.incorrectPAN = false
      this.user.pan = this.user.pan.toUpperCase()
      const regex = new RegExp('^([a-zA-Z]{5}[0-9]{4}[a-zA-Z])$')
      if (this.user.pan.length === 10 && !regex.test(this.user.pan)) {
        this.incorrectPAN = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DMIStep1/component.js